import { WorkspaceInvite } from "@/types/workspace-invite";
import { URL_PARAM_KEYS } from "@/utils/utils";

export function UseSyncActiveInvite(invites: WorkspaceInvite[]) {
  const inviteToken = sessionStorage.getItem(URL_PARAM_KEYS.INVITE);
  const inviteIndex = invites.findIndex(
    (invite) => invite.token === inviteToken,
  );
  if (inviteIndex === -1) {
    return invites; // Invite not found, return original array
  }

  const updatedInvites = [...invites];
  const [movedInvite] = updatedInvites.splice(inviteIndex, 1);
  updatedInvites.push(movedInvite);

  return updatedInvites;
}
